<template>
	<div class="wrap">
		<!-- 编辑细则 -->
		<Editxz ref="editxz" @typeList="typeList"></Editxz>
		<div class="navbar">
			<el-breadcrumb separator="/">
				<el-breadcrumb-item>党务工作</el-breadcrumb-item>
				<el-breadcrumb-item>年终考核</el-breadcrumb-item>
				<el-breadcrumb-item>优秀共产党员</el-breadcrumb-item>
				<el-breadcrumb-item>{{$route.name}}</el-breadcrumb-item>
			</el-breadcrumb>
		</div>
		<div class="datawrap">
			<div class="datatable">
				<div class="datas">
					<div class="selectbar selectbars">
						<div>{{$route.name}}</div>
						<el-button type="primary" size="small" @click="$router.go(-1)">返回上级</el-button>
					</div>
					<div class="result">
						<el-button type="primary" size="small" 
						 v-if="$store.state.user.userinfo.flag == 1"
						@click="$refs.editxz.openXz('add')">增加项目</el-button>
						<el-button type="primary" @click="putOut" size="small">导出表格</el-button>
					</div>
					<div class="selectdata">
						<template>
							<el-table
								:header-cell-style="{background:'#f5f7fa',color:'#000'}"
								:data="tableData"
								stripe
								show-overflow-tooltip
								border
								style="width: 100%">
								<el-table-column 
									prop="class_name"
									label="类别" 
									width="110">
								</el-table-column>
								<el-table-column 
									prop="score"
									label="分值" 
									align="center"
									width="80">
								</el-table-column>
								<el-table-column 
									prop="describe"
									label="评分标准(仅供参考)" >
								</el-table-column>
								<el-table-column
									 v-if="$store.state.user.userinfo.flag == 1"
									label="操作"
									align="center"
									width="98">
									<template slot-scope="scope">
										<el-button type="text" @click="$refs.editxz.editxzs(scope.row)">编辑</el-button>
										<el-button type="text" @click="delPrine(scope.row)">删除</el-button>
									</template>
								</el-table-column>
							</el-table>
						</template>
						<Page :totalPage="totalPage" :pageSize="10" @changedata="changedata"></Page>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Pfxz from './mixins/pfxz.js'
	export default {
		mixins:[Pfxz]
	}
</script>

<style lang="scss">
	.selectbars{
		width: 100%;
		border-bottom:1px solid #DDE2EE;
		>div{
			font-size: 16px;
			font-weight: bold;
			color: #1E2129;
		}
	}
	.result{
		margin-bottom: 10px;
	}
</style>

